import { useAdminStats } from '../../hooks/useAdminStats';
import { Spinner } from '../../components/ui/Spinner';

const FLAG: Record<string, string> = { MX: '🇲🇽', SV: '🇸🇻', GT: '🇬🇹', HN: '🇭🇳', CR: '🇨🇷' };

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function AdminUsuariosPage() {
  const { data, isLoading, error } = useAdminStats();

  if (isLoading) return <div className="flex justify-center pt-20"><Spinner size={40} /></div>;
  if (error || !data) return <p className="text-red-400">Error al cargar usuarios.</p>;

  const users = [...data.users].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return (
    <div>
      <h1 className="text-lg font-semibold text-white mb-4">
        Usuarios <span className="text-white/40 text-base font-normal">({users.length})</span>
      </h1>

      <div className="bg-[#1a1a2e] rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <caption className="sr-only">Lista de usuarios</caption>
          <thead>
            <tr className="border-b border-[#2a2a3e]">
              {['Usuario', 'Email', 'País', 'Ciudad', 'Rating', 'Registro'].map((col) => (
                <th key={col} className="text-left px-4 py-3 text-xs font-semibold text-white/40 uppercase tracking-wide">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.userId} className="border-b border-[#111122] hover:bg-[#0d0d1c] transition-colors">
                <td className="px-4 py-3 text-gold-400 font-medium">{u.username}</td>
                <td className="px-4 py-3 text-white/60 text-xs">{u.email}</td>
                <td className="px-4 py-3 text-white/70">
                  {u.pais ? `${FLAG[u.pais] ?? ''} ${u.pais}` : '—'}
                </td>
                <td className="px-4 py-3 text-white/60">{u.ciudad ?? '—'}</td>
                <td className="px-4 py-3">
                  {u.ratingAvg != null
                    ? <span className="text-green-400">{u.ratingAvg.toFixed(1)} <span className="text-white/40 text-xs">({u.ratingCount})</span></span>
                    : <span className="text-white/30">—</span>
                  }
                </td>
                <td className="px-4 py-3 text-white/40 text-xs">{formatDate(u.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
